module.exports = function() {
  return new Worker(__webpack_public_path__ + "c55e9ee0dc1ca78e6125.worker.js");
};